import { Component,ViewChild} from '@angular/core';
import { NavController,App,Slides,Events} from 'ionic-angular';

import { WebService } from '../../providers/service/webservice';
import { MONTHTRIPLIST,WEEKTRIPLIST} from '../../providers/config/serviceurl';
import { HEADSHOW,TRIPTYPE,MOREORONE} from '../../providers/config/constants';
import { StorageService } from '../../providers/service/storageservice';

import { Utils } from '../../providers/service/utils';
import { LoginFilter } from '../../providers/service/loginfilter';
import { AppState } from '../../app/app.global';

import { TripAddPage } from './add/tripadd';
import { TripSetPage } from './set/tripset';
import {TripView} from './tripview/tripview';


declare var $;
@Component({
  selector: 'page-trip',
  templateUrl: 'trip.html'
})
export class TripPage {
	@ViewChild('mySlider') slider: Slides;
	currentIndex:number;//当前silder页
  user:any;
  yearMonth : string;//中文年月
  type=TRIPTYPE;//week & month
  moreOrOne = MOREORONE; //表示单一某天 或者 是跨天事件
	year:string; //年
	month:string;//月
	today:string;//当天   红底白字
	selDay:string;//默认选中   黑底白字
	headShow:string=HEADSHOW;//头部是否显示
	eventList:string;//表示存在的事件
	monthNum:number;//第几个月
	twoMaxDay:number=28;
	dayNow = new Date();
	weekList:any[]=[];//单周数据
  weekList2:any[]=[];// 其他周数据
  trip:any;//单行程
  tripList:any[];//当月或者当周具体日程数据
  tripShow:any[]=[];//当天具体日程数据
  allWeekLists2:any[] = [this.weekList];//其他月  单周数据集合
	allWeekLists:any[] = [this.weekList];//当月  单周数据集合
	monthCN:string[]=['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
	monthEN:string[]=['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	dayNames:string[]=['日','一', '二', '三', '四', '五', '六'];
	monthMax:number[] = [31,this.twoMaxDay, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	suserId:string;
	dayData:any = {id:0,name:'',value:'',year:'',month:'',setPoint:false,isSelDay:false,isToday:false};
  constructor(public navCtrl: NavController,private webService:WebService,private appCtrl :App
  			,public loginFilter:LoginFilter,public events: Events
  			,public global: AppState) {
  	this.loginFilter.isToLogin();
  	this.user = StorageService.getObj('currentUser');
  	if(this.user&&this.user.userId!=null&&this.user.userId!='undefined'&&this.user.userId!=''){
  		this.suserId = this.user.userId;
  	}else{
  		this.suserId = '';
  	}
  	this.dateInit();
  	if(this.monthNum==1){
				this.monthNum = 12;
				this.year = this.parseStrToInt(this.year)-1+'';
		}else{
				this.monthNum = this.monthNum-1;
		}
		events.subscribe('popsuccess', (data) => {
    	this.reSetAllInfo();
  	});
  }

  //重置数据以及即将展示的数据
  reSetAllInfo(){
  	this.dateInit();
		this.fnSelDayBangding();
  	this.getMonthTripList(this.year,this.month,this.suserId);
  	this.tripShowList();
  }

	/*增加日程*/
	addTrip(){
		//this.showToastWithCloseButton();
		this.appCtrl.getRootNav().push(TripAddPage,{ tripList: this.tripList });
	}
	/**日历设置*/
	setCalendar(){
		this.appCtrl.getRootNav().push(TripSetPage);
	}

	/**日历查看*/
	tripView(item:any){
		this.appCtrl.getRootNav().push(TripView,{ trip:item,tripList: this.tripList,selDay:this.selDay });
	}

	//基础数据初始化
	dateInit(){
		if(!this.today){
  		this.today = Utils.dateFormat(this.dayNow,'YYYY-MM-dd');
	  	}
	  	if(!this.year){
	  		this.year = Utils.dateFormat(this.dayNow,'YYYY');
	  	}
	  	if(!this.month){
	  		this.month = Utils.dateFormat(this.dayNow,'MM');
	  	}
	  	if(!this.monthNum){
	  		this.monthNum = this.parseStrToInt(this.month);
	  	}
	  	this.reset2Month();
	  	this.yearMonth = this.year+'年  '+this.monthCN[this.monthNum-1];
	}

	//上一个月
	prevMonth(){
		if(this.monthNum==1){
			this.monthNum = 12;
			this.year = this.parseStrToInt(this.year)-1+'';
		}else{
			this.monthNum = this.monthNum-1;
		}
		this.month = this.parseInt01(this.monthNum);
		this.dateInit();
		this.fnSelDayBangding();
  	this.getMonthTripList(this.year,this.month,this.suserId);
	}

	//下一个月
	nextMonth(){
		if(this.monthNum){
			if(this.monthNum==12){
				this.monthNum = 1;
				this.year = this.parseStrToInt(this.year)+1+'';
			}else{
				this.monthNum = this.monthNum+1;
			}
			this.month = this.parseInt01(this.monthNum);
		}
		this.dateInit();
		this.fnSelDayBangding();
  	this.getMonthTripList(this.year,this.month,this.suserId);
	}
	//上一周
	prevWeek(){
		this.selDay = this.addDate(this.selDay,-7,'YYYY-MM-dd');
  	this.getWeekTripList(this.suserId);
	}
	//下一周
	nextWeek(){
		this.selDay = this.addDate(this.selDay,7,'YYYY-MM-dd');
  	this.getWeekTripList(this.suserId);
	}
	//向后滑开始
	onSlideNextStart(){
		if(this.type=='month'){//月
			this.nextMonth();
		}else if(this.type=='week'){//周
			this.nextWeek();
		}
	}
	//向前滑动开始
	onSlidePrevStart(){
		if(this.type=='month'){//月
			this.prevMonth();
		}else if(this.type=='week'){//周
			this.prevWeek();
		}
	}
	//滑动结束后执行
	onSlideDidChange(s: Slides){
    this.slider.slideTo(1,0,false);
  }

	//视图切换
	switchChange(){
		if(this.type=='month'){
			//if(this.mType.isIos()){
				$("#toolbar_hight").css("height", "40px");
				$("#ion_content_hight_id").find(".scroll-content").css("margin-top", "125px");
			/*}else{
				$("#toolbar_hight").css("height", "40px");
				$("#ion_content_hight_id").find(".scroll-content").css("margin-top", "140px");
			}*/
			this.weekList = [];
			this.type = 'week';
			this.selDay = this.addDate(this.selDay,-7,'YYYY-MM-dd');
		}else{
			//if(this.mType.isIos()){
				$("#toolbar_hight").css("height", "215px");
				$("#ion_content_hight_id").find(".scroll-content").css("margin-top", "300px");
			/*}else{
				$("#toolbar_hight").css("height", "215px");
				$("#ion_content_hight_id").find(".scroll-content").css("margin-top", "315px");
			}*/
			this.allWeekLists = [];
			this.type = 'month';
			if(this.monthNum==1){
				this.monthNum = 12;
				this.year = this.parseStrToInt(this.year)-1+'';
			}else{
				this.monthNum = this.monthNum-1;
			}
		}
	}

	//选中切换到今天
	changeToThisDay(){
		this.year = this.addDate(this.today,0,'YYYY');
		this.month = this.addDate(this.today,0,'MM');
		this.monthNum = this.parseStrToInt(this.month);
		this.dateInit();
		this.selDay = this.today;
		this.dateListInit(this.type);
		this.tripShowList();
	}

	//选中某天
	selThisDay(ddata:any){
		$(".isSelDay").removeClass("isSelDay");
		$("#"+ddata.year+ddata.month+ddata.id).find(".day").addClass("isSelDay");
		this.selDay = ddata.value;
		this.tripShowList();
	}

	//日历数据加载
	dateListInit(type:string){
		var prevMNum = 0;//上月可展现数
		var mNum = this.monthMax[this.monthNum-1];//本月
		var nextMNum = 0;//下月可展现数据
		var dnum = 0;
		var dshow = 1;
		if(type=='month'){//月视图
			this.getMonthList(prevMNum,mNum,nextMNum,dnum,dshow);
		}else{//周视图
			this.getWeekList(prevMNum,nextMNum,dnum);
		}
	}

	//设置默认选中天
	fnSelDayBangding(){
		if(!this.selDay||(this.selDay.indexOf(this.year+'-'+this.month)<=-1)){
  			this.selDay = this.year+'-'+this.month+'-01';
  	}
	}

	//获取计算结果
	returnResoult(dnum:number,i:number,obj:any){
		return obj = {id:dnum,name:i+'',value:this.year+'-'
						+this.month+'-'+this.parseInt01(i),year:this.year,month:this.month,
						setPoint:this.eventPoint(this.year,this.month,this.parseInt01(i)),
						isSelDay:this.fnIsSameday(this.selDay,this.year+'-'+this.month+'-'+this.parseInt01(i))
						,isToday:this.fnIsSameday(this.today,this.year+'-'+this.month+'-'+this.parseInt01(i))
						,isThisMonth:true};
	}

	//获取周视图数据
	getWeekList(prevMNum:number,nextMNum:number,dnum:number){
		this.weekList = [];
		if(!this.selDay){
  			this.selDay = this.year+'-'+this.month+'-01';
  	}
		this.year = this.addDate(this.selDay,0,'YYYY');
		this.month = this.addDate(this.selDay,0,'MM');
		this.monthNum = this.parseStrToInt(this.month);
		//this.dateInit();//重新加载数据
		this.yearMonth = this.year+'年  '+this.monthCN[this.monthNum-1];
		var selddday = this.addDate(this.selDay,0,'dd');
		prevMNum = this.isWeekNum(this.selDay);//本周该天之前可以显示数
		nextMNum = 7-prevMNum-1;//本周该天之后可以显示数
		for(var i=0;i<prevMNum;i++){
			var strdate = this.addDate(this.selDay,i-prevMNum,'YYYY-MM-dd');
			var stryear = this.addDate(this.selDay,i-prevMNum,'YYYY');
			var strmonth = this.addDate(this.selDay,i-prevMNum,'MM');
			var strday = this.addDate(this.selDay,i-prevMNum,'dd');
			this.dayData = {id:dnum++,name:this.parseStrToInt(strday)+'',value:strdate,year:stryear,month:strmonth,
								setPoint:this.eventPoint(stryear,strmonth,strday),isSelDay:this.fnIsSameday(this.selDay,strdate)
								,isToday:this.fnIsSameday(this.today,strdate)
								,isThisMonth:false};
			this.weekList.push(this.dayData);
		}
		this.dayData = {id:dnum++,name:this.parseStrToInt(selddday)+'',value:this.selDay,year:this.year,month:this.month,
								setPoint:this.eventPoint(this.year,this.month,selddday),isSelDay:true,isToday:this.fnIsSameday(this.today,this.selDay),isThisMonth:false};
		this.weekList.push(this.dayData);
		for( i=0;i<nextMNum;i++){
			 strdate = this.addDate(this.selDay,i+1,'YYYY-MM-dd');
			 stryear = this.addDate(this.selDay,i+1,'YYYY');
			 strmonth = this.addDate(this.selDay,i+1,'MM');
			 strday = this.addDate(this.selDay,i+1,'dd');
			this.dayData = {id:dnum++,name:this.parseStrToInt(strday)+'',value:strdate,year:stryear,month:strmonth,
								setPoint:this.eventPoint(stryear,strmonth,strday),isSelDay:this.fnIsSameday(this.selDay,strdate)
								,isToday:this.fnIsSameday(this.today,strdate)
								,isThisMonth:false};
			this.weekList.push(this.dayData);
		}
	}

	//获取月视图具体数据
	getMonthList(prevMNum:number,mNum:number,nextMNum:number,dnum:number,dshow:number){
      var selWeekList:any[] = [this.weekList];
      selWeekList = [];
			prevMNum = this.isWeekNum(this.year+'-'+this.month+'-01');//返回的数字也是上月可显示数
			nextMNum = 42-mNum-prevMNum;
			for(var i=1;i<6;i++){
				this.weekList = [];
				if(i==1){
					var pMNum = 0;
					if(this.monthNum<2){
						pMNum = this.monthMax[11];//上月
					}else if(this.monthNum==3){
						this.monthNum = 2
						this.reset2Month();
						this.monthNum = 3
						pMNum = this.monthMax[this.monthNum-2];//上月
					}else{
						pMNum = this.monthMax[this.monthNum-2];//上月
					}
					for(var j=0;j<prevMNum;j++){
						this.dayData = {id:dnum++,name:pMNum-(prevMNum-j-1)+'',value:'',year:'',month:'',setPoint:false,isSelDay:false,isToday:false,isThisMonth:false};
						this.weekList.push(this.dayData);
					}
					for( j=1;j<(8-prevMNum);j++){
						this.weekList.push(this.returnResoult(dnum++,dshow++,this.dayData));
					}
				}else if(i==5){
					var nextNum = 1;
					if(nextMNum>7){
						for( j=1;j<(8-(nextMNum-7));j++){
							this.weekList.push(this.returnResoult(dnum++,dshow++,this.dayData));
						}
						for( j=1;j<(nextMNum-7)+1;j++){
							this.dayData = {id:dnum++,name:''+nextNum++,value:'',year:'',month:'',setPoint:false,isSelDay:false,isToday:false,isThisMonth:false};
							this.weekList.push(this.dayData);
						}
						selWeekList.push(this.weekList);
						this.weekList = [];
						for( j=1;j<8;j++){
							this.dayData = {id:dnum++,name:''+nextNum++,value:'',year:'',month:'',setPoint:false,isSelDay:false,isToday:false,isThisMonth:false};
							this.weekList.push(this.dayData);
						}
					}else{
						for( j=1;j<8;j++){
							this.weekList.push(this.returnResoult(dnum++,dshow++,this.dayData));
						}
						selWeekList.push(this.weekList);
						this.weekList = [];
						for( j=1;j<8-nextMNum;j++){
							this.weekList.push(this.returnResoult(dnum++,dshow++,this.dayData));
						}
						for( j=1;j<nextMNum+1;j++){
							this.dayData = {id:dnum++,name:''+nextNum++,value:'',year:'',month:'',setPoint:false,isSelDay:false,isToday:false,isThisMonth:false};
							this.weekList.push(this.dayData);
						}
					}
				}else{
					for(var j3=1;j3<8;j3++){
						this.weekList.push(this.returnResoult(dnum++,dshow++,this.dayData));
					}
				}
        selWeekList.push(this.weekList);
			}
      this.allWeekLists = selWeekList;
	}
	//重设二月最大日期
	reset2Month(){
		if(this.monthNum==2){
	  		if(this.isLeapYear(this.parseStrToInt(this.year))){
	  			this.twoMaxDay = 29;
	  			this.monthMax= [31,this.twoMaxDay, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	  		}
	  	}
	}
	//日期加减法  date参数为计算开始的日期，days为需要加的天数
  //格式:addDate('2017-1-11',20,format)
	addDate(date,days,format:string){
		date = date.replace('T',' ');
    var d=new Date(date);
    d.setDate(d.getDate()+days);
    return Utils.dateFormat(d,format)+'';
	}

	//字符串 10进制取整数
	parseStrToInt(str:string){
		return parseInt(str, 10);
	}
	//数字转换
	parseInt01(d:number){
		return d>9?(d+''):('0'+d);
	}
	//是否是闰年
	isLeapYear(y:number){
		return  (y % 4 == 0) && (y % 100 != 0 || y % 400 == 0);
	}
	//返回今天是星期几 --周日是 0  周六是6
	isWeekNum(day:string){
		return new Date(Date.parse(day.replace(/-/g, "/"))).getDay();
	}
	//判断是否是同一天
	fnIsSameday(sdate:string,sdate1:string){
		if(!sdate||!sdate1){
			return false;
		}else{
			if(sdate==sdate1){
				return true;
			}else{
				return false;
			}
		}
	}

	//事件显示
	eventPoint(y:string,m:string,d:string){
		var ymd = y+'-'+m+'-'+d;
		if(this.tripList!=null&&this.tripList.length>0){
			var length = this.tripList.length;
			for(var i=0;i<length;i++){
				this.trip = this.tripList[i];
				if(ymd>=this.trip.timeStarts.substr(0,10)){
					var sy = this.trip.timeStarts.substr(0,4);
					var sm = this.trip.timeStarts.substr(5,2);
					var sd = this.trip.timeStarts.substr(8,2);
					var symd = this.trip.timeStarts.substr(0,10);

					var ey = this.trip.timeEnds.substr(0,4);
					var em = this.trip.timeEnds.substr(5,2);
					var ed = this.trip.timeEnds.substr(8,2);
					var eymd = this.trip.timeEnds.substr(0,10);

					var dif1 = Utils.dateDiff(symd,eymd); //开始到结束 天差数
					var dif2 = Utils.dateDiff(symd,ymd);//选中天到开始那天 天差数
					if(this.trip.repeatValue=='day'){//重复  天
						if(this.trip.endRepeatTime!='0'){
							if(ymd<=this.addDate(this.trip.endRepeatTime.substr(0,10),(dif1-1),'YYYY-MM-dd')){
								return true;
							}
						}else{
							if(this.trip.timeStarts.substr(0,10)<=ymd){
								return true;
							}
						}
					}else if(this.trip.repeatValue=='week'){//重复  周
						if(this.trip.endRepeatTime!='0'){
							var dif4 = Utils.dateDiff(symd,this.trip.endRepeatTime.substr(0,10));//结束日期天到开始那天 天差数
							var addNum = dif4%7==0?7:dif4%7;
							if(ymd<=this.addDate(this.trip.endRepeatTime.substr(0,10),(dif1-addNum),'YYYY-MM-dd')){
								return (0<=dif2%7&&dif2%7<=dif1);
							}
						}else{
							return (0<=dif2%7&&dif2%7<=dif1);
						}
					}else if(this.trip.repeatValue=='month'){//重复 月
						var mSub = (this.parseStrToInt(ey)-this.parseStrToInt(sy))*12+this.parseStrToInt(em)-this.parseStrToInt(sm); // 月差
						if(this.trip.endRepeatTime!='0'){
							//var dif4 = Utils.dateDiff(symd,this.trip.endRepeatTime.substr(0,10));//结束日期天到开始那天 天差数
							var edy = this.trip.endRepeatTime.substr(0,4);
							var edm = this.trip.endRepeatTime.substr(5,2);
							var edd = this.trip.endRepeatTime.substr(8,2);
							var subD = this.parseStrToInt(edd)-this.parseStrToInt(ed);//重复结束日 到 结束日那天 天差数
							if(sd<=d&&d<=ed&&(sy+sm)==(ey+em)&&ymd<=this.addDate(this.trip.endRepeatTime.substr(0,10),(dif1-subD),'YYYY-MM-dd')){
								return true;
							}else if((sy+sm)<(ey+em)){
								var needSub = 0;
								if(sd>=edd){
									needSub = 1
								}
								if(mSub>1&&ymd<=(Utils.addMonth((edy+'-'+edm+'-'+ed),mSub-needSub,'YYYY-MM-dd'))){
										return true;
								}else if((sd<=d||d<=ed)&&ymd<=(Utils.addMonth((edy+'-'+edm+'-'+ed),1-needSub,'YYYY-MM-dd'))){
									return true;
								}
							}
						}else{
							if(sd<=d&&d<=ed&&(sy+sm)==(ey+em)){
								return true;
							}else if((sy+sm)<(ey+em)){
								if(mSub>1){
									return true;
								}else if(sd<=d||d<=ed){
									return true;
								}
							}
						}
					}else if(this.trip.repeatValue=='year'){//重复  年
            var ySub = this.parseStrToInt(ey)-this.parseStrToInt(sy); // 年差
						 mSub = (this.parseStrToInt(ey)-this.parseStrToInt(sy))*12+this.parseStrToInt(em)-this.parseStrToInt(sm); // 月差
						if(this.trip.endRepeatTime!='0'){
							 edy = this.trip.endRepeatTime.substr(0,4);
							 edm = this.trip.endRepeatTime.substr(5,2);
							 edd = this.trip.endRepeatTime.substr(8,2);
							var needYSub = false;
							var subyear = 0;
							if((edm+'-'+edd)<(sm+'-'+sd)){
								needYSub = true;
								subyear = this.parseStrToInt(edy)-1+ySub;
							}else{
								subyear = this.parseStrToInt(edy)+ySub;
							}
							if(sy==ey&&(sm+'-'+sd)<=(m+'-'+d)&&(m+'-'+d)<=(em+'-'+ed)){
								if(needYSub&&ymd<=(subyear+'-'+em+'-'+ed)){
									return true;
								}else if(ymd<=(subyear+'-'+em+'-'+ed)){
									return true;
								}
								return false;
							}else if(ey>sy){
								if(ySub==1){
									if((sm+'-'+sd)>(em+'-'+ed)){
										if(((sm+'-'+sd)<=(m+'-'+d)||(m+'-'+d)<=(em+'-'+ed))){
											if(needYSub&&ymd<=(subyear+'-'+em+'-'+ed)){
												return true;
											}else if(ymd<=(subyear+'-'+em+'-'+ed)){
												return true;
											}
										}
										return false;
									}else{
										if(needYSub&&ymd<=(subyear+'-'+em+'-'+ed)){
											return true;
										}else if(ymd<=(subyear+'-'+em+'-'+ed)){
											return true;
										}
										return false;
									}
								}else{
									if(needYSub&&ymd<=(subyear+'-'+em+'-'+ed)){
										return true;
									}else if(ymd<=(subyear+'-'+em+'-'+ed)){
										return true;
									}
									return false;
								}
							}
						}else{
							if(sy==ey&&(sm+'-'+sd)<=(m+'-'+d)&&(m+'-'+d)<=(em+'-'+ed)){
								return true;
							}else if(ey>sy){
								if(ySub==1){
									if((sm+'-'+sd)>(em+'-'+ed)){
										if(((sm+'-'+sd)<=(m+'-'+d)||(m+'-'+d)<=(em+'-'+ed))){
											return true;
										}
									}else{
										return true;
									}
								}else{return true;}
							}
						}
					}else{//不重复
						if(this.trip.timeStarts.substr(0,10)<=ymd&&ymd<=this.trip.timeEnds.substr(0,10)){
							return true;
						}
					}
				}
			}
		}
		return false;
	}
	//日程显示列表
	tripShowList(){
		if(this.tripList==null||this.tripList.length==0){
			return;
		}
		var length = this.tripList.length;
		this.tripShow = [];
		if(this.tripList){
			var y = this.selDay.substr(0,4);
			var m = this.selDay.substr(5,2);
			var d = this.selDay.substr(8,2);
			for(var i=0;i<length;i++){
				this.trip = this.tripList[i];
				this.trip.showSTime='';
				this.trip.showETime='';
				if(this.selDay>=this.trip.timeStarts.substr(0,10)){
					var sy = this.trip.timeStarts.substr(0,4);
					var sm = this.trip.timeStarts.substr(5,2);
					var sd = this.trip.timeStarts.substr(8,2);
					var st = this.trip.timeStarts.substr(11,5);
					var symd = this.trip.timeStarts.substr(0,10);

					var ey = this.trip.timeEnds.substr(0,4);
					var em = this.trip.timeEnds.substr(5,2);
					var ed = this.trip.timeEnds.substr(8,2);
					var et = this.trip.timeEnds.substr(11,5);
					var eymd = this.trip.timeEnds.substr(0,10);
					var dif1 = Utils.dateDiff(symd,eymd); //开始到结束 天差数
					var dif2 = Utils.dateDiff(symd,this.selDay);//选中天到开始那天 天差数

					if(this.trip.repeatValue=='day'){//重复  天
						this.showDay(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2);
					}else if(this.trip.repeatValue=='week'){//重复  周
						this.showWeek(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2);
					}else if(this.trip.repeatValue=='month'){//重复 月
						this.showMonth(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2);
					}else if(this.trip.repeatValue=='year'){//重复  年
						this.showYear(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2);
					}else{//不重复
						if(dif2<=dif1){
							if(this.trip.isAll=='1'){
								this.trip.showSTime='全天';
								this.trip.ordertime='1';
								if(this.moreOrOne=="one"){
									this.trip.showETime='';
								}else{
									this.trip.showETime=eymd+' 结束';
								}
							}else{
								if(dif2==0){
									this.trip.showSTime=st;
									this.trip.ordertime='3';
								}else if(dif2==dif1){
									this.trip.showSTime='00:00';
									this.trip.ordertime='2';
								}else{
									this.trip.showSTime='全天';
									this.trip.ordertime='1';
								}
								if(this.moreOrOne=="one"){
									this.trip.showETime=et+'';
								}else{
									this.trip.showETime=eymd+' '+et+' 结束';
								}
							}
							this.tripShow.push(this.trip);
						}
					}
				}
			}
		}
		//处理展示数据 做个简单排序
		Utils.listSort(this.tripShow);
	}

	showDay(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2){//获取 日 的行程
		var daylen = -1;
		var isEndT = false;
		if(dif2<=dif1){
			daylen = dif2;
		}else{
			var edymd = this.trip.endRepeatTime.substr(0,10);
			if(this.trip.endRepeatTime=='0'||this.selDay<edymd){
				daylen = dif1;
			}else{
				if(this.selDay>=edymd&&this.selDay<this.addDate(edymd,dif1,'YYYY-MM-dd')){
					var dif3 = Utils.dateDiff(edymd,this.selDay);//选中天到开始那天 天差数
					isEndT = true;
					daylen = dif1-dif3-1;
				}
			}
		}
		for(var i=0;i<(daylen+1);i++){
			var ttrip =Utils.deepClone(this.trip);//深度复制
			if(ttrip.isAll=='1'){
				ttrip.showSTime="全天";
				ttrip.ordertime='1';
				if(this.moreOrOne=="one"){
					ttrip.showETime='';
				}else{
					if(isEndT){
						ttrip.showETime=this.addDate(ttrip.endRepeatTime.substr(0,10),(dif1-i-1),'YYYY-MM-dd')+' 结束';
					}else{
						ttrip.showETime=this.addDate(eymd,(dif2-i),'YYYY-MM-dd')+" 结束";
					}
				}
			}else{
				if(i==0&&!isEndT){
					ttrip.showSTime=st;
					ttrip.ordertime='3';
				}else if(i==daylen&&dif2>=dif1){
					ttrip.showSTime='00:00';
					ttrip.ordertime='2';
				}else{
					ttrip.showSTime='全天';
					ttrip.ordertime='1';
				}
				if(this.moreOrOne=="one"){
					ttrip.showETime=et+'';
				}else{
					if(isEndT){
						ttrip.showETime=this.addDate(ttrip.endRepeatTime.substr(0,10),(dif1-i-1),'YYYY-MM-dd')+' '+et+' 结束';
					}else{
						ttrip.showETime=this.addDate(eymd,(dif2-i),'YYYY-MM-dd')+' '+et+' 结束';
					}
				}
			}
			this.tripShow.push(ttrip);
		}
	}
	showWeek(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2){//获取 周 的行程
		var weeklen = -1;//循环数
		var isEndT = false; //是否设计结束重复时间 或是时间区间影响
		var wSubNum = dif2%7;
		var wSubNum2 = Math.floor(dif2/7);//选中天差 向下取整 除7
		var d2d1SNum = dif2%dif1;
		var d2d1MoSNum = d2d1SNum==0?dif1:d2d1SNum;
		var d2d1SNum2 = Math.floor(dif1/7);//时间段差 向下取整 除7
		var d2d1SNum4 = dif1%7;//时间段差 模7
		var edymd = ''; //结束年月日
		var edmod = 0; //结束模值
		if(dif1<7){
			if(dif1>=wSubNum){
				if(this.trip.endRepeatTime!='0'){
						edymd = this.trip.endRepeatTime.substr(0,10);
						edmod = Utils.dateDiff(symd,edymd)%7; //开始到结束 天差数
						edmod = edmod==0?7:edmod;
						if(this.selDay<=this.addDate(edymd,(dif1-edmod),'YYYY-MM-dd')){
							weeklen = 1;
						}
				}else{
					weeklen = 1;
				}
			}
		}else{
			if(wSubNum2==0){
				weeklen = 1;
			}else{
				if(this.selDay<=eymd){
					var moSub = Math.floor(d2d1MoSNum/7);
					weeklen = moSub+1;
				}else{
					if(this.trip.endRepeatTime!='0'){
						edymd = this.trip.endRepeatTime.substr(0,10);
						edmod = Utils.dateDiff(symd,edymd)%7; //开始到结束 天差数
						edmod = edmod==0?7:edmod;
						if(this.selDay<=this.addDate(edymd,dif1-edmod,'YYYY-MM-dd')){
							if(this.selDay>=edymd){
								edmod = Utils.dateDiff(symd,edymd)%7; //开始到结束 天差数
								edmod = edmod==0?7:edmod;
								isEndT = true;
								var sid1 = Math.floor(Utils.dateDiff(edymd,this.selDay)/7);//选中天到结束重复+dif1 那天 天差数
								weeklen = d2d1SNum2-sid1;
							}else if((wSubNum<=d2d1SNum4)||wSubNum==0){
								weeklen = d2d1SNum2+1;
							}else{
								weeklen = d2d1SNum2;
							}
						}
					}else if((wSubNum<=d2d1SNum4)||wSubNum==0){
						weeklen = d2d1SNum2+1;
					}else{
						weeklen = d2d1SNum2;
					}
				}
			}
		}
		for(var i=0;i<weeklen;i++){
				var wtrip =Utils.deepClone(this.trip);//深度复制
				if(wtrip.isAll=='1'){
					wtrip.showSTime="全天";
					wtrip.ordertime='1';
					if(this.moreOrOne=="one"){
						wtrip.showETime='';
					}else{
						if(isEndT){
							wtrip.showETime=this.addDate(this.addDate(edymd,-edmod,'YYYY-MM-dd'),(dif1-i*7),'YYYY-MM-dd')+' 结束';
						}else{
							wtrip.showETime=this.addDate(symd,((wSubNum2-i)*7+dif1),'YYYY-MM-dd')+" 结束";
						}
					}

				}else{
					if(i==0){
						if(!isEndT&&wSubNum==0){
							wtrip.showSTime=st;
							wtrip.ordertime='3';
						}else if(wSubNum==dif1||(isEndT&&(wSubNum==d2d1SNum4))){
							wtrip.showSTime='00:00';
							wtrip.ordertime='2';
						}else{
							wtrip.showSTime='全天';
							wtrip.ordertime='1';
						}
					}else if(i==(weeklen-1)&&(wSubNum==dif1||d2d1SNum==0||(wSubNum==d2d1SNum4))){
						wtrip.showSTime='00:00';
						wtrip.ordertime='2';
					}else{
						wtrip.showSTime='全天';
						wtrip.ordertime='1';
					}
					if(this.moreOrOne=="one"){
						wtrip.showETime=et+'';
					}else{
						if(isEndT){
							wtrip.showETime=this.addDate(this.addDate(edymd,-edmod,'YYYY-MM-dd'),(dif1-i*7),'YYYY-MM-dd')+' '+et+' 结束';
						}else{
							wtrip.showETime=this.addDate(symd,((wSubNum2-i)*7+dif1),'YYYY-MM-dd')+' '+et+' 结束';
						}
					}
				}
				this.tripShow.push(wtrip);
		}
	}
	/**
	 * y:选中当年  m:选中当月  d:选中当日
	 * sy:开始当年  sm:开始当月 sd:开始当日 symd:开始年月日
	 * ey:结束当年  em:结束当月 ed:结束当日 eymd:结束年月日
	 * dif1:开始到结束 天差数
	 * dif2:选中天到开始那天 天差数
	 */
	showMonth(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2){//获取 月 的行程
		var meeklen = -1;//循环数
		var isEndT = false; //是否设计结束重复时间 或是时间区间影响
		var mSub = (this.parseStrToInt(ey)-this.parseStrToInt(sy))*12+this.parseStrToInt(em)-this.parseStrToInt(sm); // 月差
		var mSub2 = (this.parseStrToInt(y)-this.parseStrToInt(sy))*12+this.parseStrToInt(m)-this.parseStrToInt(sm); // 月差
		var needAdd = 1;
		if(((d<=sd||(sd<=d&&d<=ed))&&y+m>sy+sm)||mSub==0){needAdd = 0;}
		var moreMonthAdd = 0;
		if(this.trip.endRepeatTime!='0'){
			var edy = this.trip.endRepeatTime.substr(0,4);
			var edm = this.trip.endRepeatTime.substr(5,2);
			var edd = this.trip.endRepeatTime.substr(8,2);
			var edymd = this.trip.endRepeatTime.substr(0,10);
			var subD = this.parseStrToInt(edd)-this.parseStrToInt(ed);//重复结束日 到 结束日那天 天差数
			var subD2 = this.parseStrToInt(ed)-this.parseStrToInt(sd);//重复结束日 到 结束日那天 天差数
			if(this.selDay==this.addDate(Utils.addMonth(edymd,mSub,'YYYY-MM-dd'),-subD-subD2,'YYYY-MM-dd')){
				isEndT = true;}
			if(sd<=d&&d<=ed&&(sy+sm)==(ey+em)&&this.selDay<=this.addDate(edymd,(dif1-subD),'YYYY-MM-dd')){
				meeklen = 1;
			}else if((sy+sm)<(ey+em)){
				var needSub = 0;
				if(sd>=edd){needSub = 1;}
				if(mSub>1&&this.selDay<=(Utils.addMonth((edy+'-'+edm+'-'+ed),mSub-needSub,'YYYY-MM-dd'))){
					var mdif = Math.floor(mSub2/mSub);
					var mmo = mSub2%mSub;
					moreMonthAdd = mdif*mSub-((mSub-mmo)*mdif/(mdif==0?1:mdif))+mSub-mSub2;
					if(this.selDay<=eymd){
						needAdd = 0;
						meeklen = mSub2+1;
						if(d<sd){meeklen = meeklen-1;}
					}else if(this.selDay>=(edy+'-'+edm+'-'+sd)){
						isEndT = true;
						var mSub3 = (this.parseStrToInt(y)-this.parseStrToInt(edy))*12+this.parseStrToInt(m)-this.parseStrToInt(edm); // 月差
						meeklen = mSub - (needSub+mSub3);
						if(mSub3==0){if(edd>sd){isEndT=false;}}
						if(d<=ed){meeklen = meeklen+1;}
						if(sd>ed){
							if(this.selDay>symd&&this.selDay==y+'-'+m+'-'+sd){
								moreMonthAdd = moreMonthAdd+1;
							}
						}
						if(ed<d&&d<sd&&this.selDay>sy+'-'+sm+'-'+ed){
							moreMonthAdd =moreMonthAdd+1;
						}
					}else{
						if(sd<=d&&d<=ed&&this.selDay>sy+'-'+sm+'-'+ed){
							meeklen = mSub+1;
						}else if(ed<d&&d<sd&&this.selDay>sy+'-'+sm+'-'+ed){
							isEndT = true;
							meeklen = mSub-1;
							moreMonthAdd =moreMonthAdd+1;
						}else{
							meeklen = mSub;
							if(sd>ed){
								if(this.selDay>symd&&this.selDay==y+'-'+m+'-'+sd){
									moreMonthAdd = moreMonthAdd+1;
								}
							}
						}
					}
				}else if((sd<=d||d<=ed)&&this.selDay<=(Utils.addMonth((edy+'-'+edm+'-'+ed),1-needSub,'YYYY-MM-dd'))){
					if(sd>ed){
						meeklen = 1;
						if(this.selDay>symd&&this.selDay==y+'-'+m+'-'+sd){
							moreMonthAdd = 1;
						}
					}else{
						if(sd<=d&&d<=ed&&this.selDay>sy+'-'+sm+'-'+ed&&this.selDay<this.addDate(Utils.addMonth(edymd,mSub,'YYYY-MM-dd'),-subD-subD2,'YYYY-MM-dd')){
							meeklen = 2;
						}else{meeklen = 1;}
					}
				}
			}
		}else{
			if(sd<=d&&d<=ed&&(sy+sm)==(ey+em)){
				meeklen = 1;
			}else if((sy+sm)<(ey+em)){
				if(mSub>1){
					 mdif = Math.floor(mSub2/mSub);
					 mmo = mSub2%mSub;
					moreMonthAdd = mdif*mSub-((mSub-mmo)*mdif/(mdif==0?1:mdif))+mSub-mSub2;
					if(this.selDay<=eymd){
						needAdd = 0;
						meeklen = mSub2+1;
						if(d<sd){meeklen = meeklen-1;}
					}else{
						if(sd<=d&&d<=ed&&this.selDay>sy+'-'+sm+'-'+ed){
							meeklen = mSub+1;
						}else if(ed<d&&d<sd&&this.selDay>sy+'-'+sm+'-'+ed){
							isEndT = true;
							meeklen = mSub-1;
							moreMonthAdd =moreMonthAdd+1;
						}else{
							meeklen = mSub;
							if(sd>ed){
								if(this.selDay>symd&&this.selDay==y+'-'+m+'-'+sd){
									moreMonthAdd = moreMonthAdd+1;
								}
							}
						}
					}
				}else if(sd<=d||d<=ed){
					if(sd>ed){
						meeklen = 1;
						if(this.selDay>symd&&this.selDay==y+'-'+m+'-'+sd){
							moreMonthAdd = 1;
						}
					}else{
						if(sd<=d&&d<=ed&&this.selDay>sy+'-'+sm+'-'+ed){
							meeklen = 2;
						}else{meeklen = 1;}
					}
				}
			}
		}
		for(var i=0;i<meeklen;i++){
			var mtrip =Utils.deepClone(this.trip);//深度复制
			if(mtrip.isAll=='1'){
				mtrip.showSTime="全天";
				mtrip.ordertime='1';
				if(this.moreOrOne=="one"){
						mtrip.showETime='';
				}else{
						mtrip.showETime=Utils.addMonth(y+'-'+m+'-'+ed,(meeklen-i-1)+needAdd+moreMonthAdd,'YYYY-MM-dd')+' 结束';
				}
			}else{
				if(i==0&&d==sd&&!isEndT){
					mtrip.showSTime=st;
					mtrip.ordertime='3';
				}else if(i==(meeklen-1)&&d==ed&&this.selDay>=eymd){
					mtrip.showSTime='00:00';
					mtrip.ordertime='2';
				}else{
					mtrip.showSTime='全天';
					mtrip.ordertime='1';
				}
				if(this.moreOrOne=="one"){
						mtrip.showETime=et+'';
				}else{
						mtrip.showETime=Utils.addMonth(y+'-'+m+'-'+ed,(meeklen-i-1)+needAdd+moreMonthAdd,'YYYY-MM-dd')+' '+et+' 结束';
				}
			}
			this.tripShow.push(mtrip);
		}
	}
	showYear(y,m,d,sy,sm,sd,st,symd,ey,em,ed,et,eymd,dif1,dif2){//获取 年 的行程
		var yearlen = -1;//循环数
		var isEndT = false; //是否设计结束重复时间 或是时间区间影响
		var ySub = this.parseStrToInt(ey)-this.parseStrToInt(sy); // 年差
		var ySub2 = this.parseStrToInt(y)-this.parseStrToInt(sy); // 年差
		//var mSub = (this.parseStrToInt(ey)-this.parseStrToInt(sy))*12+this.parseStrToInt(em)-this.parseStrToInt(sm); // 月差
		var needYsubNum = 0;
		var needYsubNum2 = 0;
		if(this.trip.endRepeatTime!='0'){
			//var edymd = this.trip.endRepeatTime.substr(0,10);
			var edy = this.trip.endRepeatTime.substr(0,4);
			var edm = this.trip.endRepeatTime.substr(5,2);
			var edd = this.trip.endRepeatTime.substr(8,2);
			var needYSub = false;
			var subyear = 0;
			if((edm+'-'+edd)<(sm+'-'+sd)){
				needYSub = true;
				subyear = this.parseStrToInt(edy)-1+ySub;
			}else{
				subyear = this.parseStrToInt(edy)+ySub;
			}
			if(sy==ey&&(sm+'-'+sd)<=(m+'-'+d)&&(m+'-'+d)<=(em+'-'+ed)){
				if(needYSub&&this.selDay<=(subyear+'-'+em+'-'+ed)){
					yearlen = 1;
				}else if(this.selDay<=(subyear+'-'+em+'-'+ed)){
					yearlen = 1;
				}
			}else if(ey>sy){
				if(ySub==1){
					if((sm+'-'+sd)>(em+'-'+ed)){
						if(y>sy){needYsubNum++};
						if(((sm+'-'+sd)<=(m+'-'+d)||(m+'-'+d)<=(em+'-'+ed))){
							if(needYSub&&this.selDay<=(subyear+'-'+em+'-'+ed)){
								yearlen = 1;
							}else if(this.selDay<=(subyear+'-'+em+'-'+ed)){
								yearlen = 1;
							}
						}
					}else{
						var x=0;
						if(this.selDay<=(subyear+'-'+em+'-'+ed)&&this.selDay>=((subyear-ySub)+'-'+sm+'-'+sd)){
							x = 1;isEndT=true;
						}
						if(needYSub&&this.selDay<=(subyear+'-'+em+'-'+ed)){
							if((m+'-'+d)<=(em+'-'+ed)&&y>sy){needYsubNum = 1;}
							if((m+'-'+d)>=(sm+'-'+sd)&&(m+'-'+d)<=(em+'-'+ed)&&y>sy){yearlen = 2-x;}else{yearlen = 1;}
						}else if(this.selDay<=(subyear+'-'+em+'-'+ed)){
							if((m+'-'+d)<=(em+'-'+ed)&&y>sy){needYsubNum = 1;}
							if((m+'-'+d)>=(sm+'-'+sd)&&(m+'-'+d)<=(em+'-'+ed)&&y>sy){yearlen = 2-x;}else{yearlen = 1;}
						}
					}
				}else{
					 x=0;
					if(this.selDay<=(subyear+'-'+em+'-'+ed)&&this.selDay>=((subyear-ySub)+'-'+sm+'-'+sd)){
						x = (this.parseStrToInt(y)-(subyear-ySub)-1);isEndT=true;
					}
					if(needYSub&&this.selDay<=(subyear+'-'+em+'-'+ed)){
						if((em+'-'+ed)>(sm+'-'+sd)){
							if(((m+'-'+d)<(em+'-'+ed)||(m+'-'+d)>=(em+'-'+ed))&&y>sy){needYsubNum++;}
							if((m+'-'+d)<=(em+'-'+ed)&&y>=ey){needYsubNum++;}
							if(y<ey){
								if((m+'-'+d)<(sm+'-'+sd)&&y<=ey){needYsubNum2 = 1;}
								yearlen = ySub2+1-needYsubNum2;
							}else{
								if(((m+'-'+d)<=(em+'-'+ed)&&(m+'-'+d)>=(sm+'-'+sd))&&y>=ey){needYsubNum2--;}
								yearlen = ySub-needYsubNum2-x;
							}
						}else if((sm+'-'+sd)>=(em+'-'+ed)){
							if((m+'-'+d)<=(sm+'-'+sd)&&y>sy){needYsubNum = 1;}
							if((m+'-'+d)<(sm+'-'+sd)&&y<ey){needYsubNum2 = 1;}
							if((m+'-'+d)>(em+'-'+ed)&&(m+'-'+d)<(sm+'-'+sd)&&y>=ey){needYsubNum2 = 1;}
							if(((m+'-'+d)>(sm+'-'+sd)&&y>sy)||((m+'-'+d)<=(em+'-'+ed)&&y>=ey)){needYsubNum++;}
							if(y<ey){
								yearlen = ySub2+1-needYsubNum2;
							}else{
								yearlen = ySub-needYsubNum2-x;
							}
						}
					}else if(this.selDay<=(subyear+'-'+em+'-'+ed)){
						if((em+'-'+ed)>(sm+'-'+sd)){
							if(((m+'-'+d)<(em+'-'+ed)||(m+'-'+d)>=(em+'-'+ed))&&y>sy){needYsubNum++;}
							if((m+'-'+d)<=(em+'-'+ed)&&y>=ey){needYsubNum++;}
							if(y<ey){
								if((m+'-'+d)<(sm+'-'+sd)&&y<=ey){needYsubNum2 = 1;}
								yearlen = ySub2+1-needYsubNum2;
							}else{
								if(((m+'-'+d)<=(em+'-'+ed)&&(m+'-'+d)>=(sm+'-'+sd))&&y>=ey){needYsubNum2--;}
								yearlen = ySub-needYsubNum2-x;
							}
						}else if((sm+'-'+sd)>=(em+'-'+ed)){
							if((m+'-'+d)<=(sm+'-'+sd)&&y>sy){needYsubNum = 1;}
							if((m+'-'+d)<(sm+'-'+sd)&&y<ey){needYsubNum2 = 1;}
							if((m+'-'+d)>(em+'-'+ed)&&(m+'-'+d)<(sm+'-'+sd)&&y>=ey){needYsubNum2 = 1;}
							if(((m+'-'+d)>(sm+'-'+sd)&&y>sy)||((m+'-'+d)<=(em+'-'+ed)&&y>=ey)){needYsubNum++;}
							if(y<ey){
								yearlen = ySub2+1-needYsubNum2;
							}else{
								yearlen = ySub-needYsubNum2-x;
							}
						}
					}
				}
			}
		}else{
			if(sy==ey&&(sm+'-'+sd)<=(m+'-'+d)&&(m+'-'+d)<=(em+'-'+ed)){
				yearlen = 1;
			}else if(ey>sy){
				if(ySub==1){
					if((sm+'-'+sd)>(em+'-'+ed)){
						if(((sm+'-'+sd)<=(m+'-'+d)||(m+'-'+d)<=(em+'-'+ed))){
							yearlen = 1;
							if((m+'-'+d)<=(em+'-'+ed)){needYsubNum = 1;}
						}
					}else{
						if((m+'-'+d)<=(em+'-'+ed)){needYsubNum = 1;}
						if((m+'-'+d)>=(sm+'-'+sd)&&(m+'-'+d)<=(em+'-'+ed)&&y>sy){yearlen = 2;}else{yearlen = 1;}
					}
				}else{
					if((em+'-'+ed)>(sm+'-'+sd)){
						if(((m+'-'+d)<(em+'-'+ed)||(m+'-'+d)>=(em+'-'+ed))&&y>sy){needYsubNum++;}
						if((m+'-'+d)<=(em+'-'+ed)&&y>=ey){needYsubNum++;}
						if(y<ey){
							if((m+'-'+d)<(sm+'-'+sd)&&y<=ey){needYsubNum2 = 1;}
							yearlen = ySub2+1-needYsubNum2;
						}else{
							if(((m+'-'+d)<=(em+'-'+ed)&&(m+'-'+d)>=(sm+'-'+sd))&&y>=ey){needYsubNum2--;}
							yearlen = ySub-needYsubNum2;
						}
					}else if((sm+'-'+sd)>=(em+'-'+ed)){
						if((m+'-'+d)<=(sm+'-'+sd)&&y>sy){needYsubNum = 1;}
						if((m+'-'+d)<(sm+'-'+sd)&&y<ey){needYsubNum2 = 1;}
						if((m+'-'+d)>(em+'-'+ed)&&(m+'-'+d)<(sm+'-'+sd)&&y>=ey){needYsubNum2 = 1;}
						if(((m+'-'+d)>(sm+'-'+sd)&&y>sy)||((m+'-'+d)<=(em+'-'+ed)&&y>=ey)){needYsubNum++;}
						if(y<ey){
							yearlen = ySub2+1-needYsubNum2;
						}else{
							yearlen = ySub-needYsubNum2;
						}
					}
				}
			}
		}
		for(var i=0;i<yearlen;i++){
			var ytrip =Utils.deepClone(this.trip);//深度复制
			if(ytrip.isAll=='1'){
				ytrip.showSTime="全天";
				ytrip.ordertime='1';
				if(this.moreOrOne=="one"){
						ytrip.showETime='';
				}else{
						ytrip.showETime=(this.parseStrToInt(y)+(yearlen-i-1)+ySub-needYsubNum)+'-'+em+'-'+ed+' 结束';
				}
			}else{
				if(i==0&&(m+d)==(sm+sd)&&!isEndT){
					ytrip.showSTime=st;
					ytrip.ordertime='3';
				}else if(i==(yearlen-1)&&(m+d)==(em+ed)&&this.selDay>=eymd){
					ytrip.showSTime='00:00';
					ytrip.ordertime='2';
				}else{
					ytrip.showSTime='全天';
					ytrip.ordertime='1';
				}
				if(this.moreOrOne=="one"){
						ytrip.showETime=et+'';
				}else{
						ytrip.showETime=(this.parseStrToInt(y)+(yearlen-i-1)+ySub-needYsubNum)+'-'+em+'-'+ed+' '+et+' 结束';
				}
			}
			this.tripShow.push(ytrip);
		}
	}

	getMonthTripList(year:string,month:string,userId:string){
		if(userId!=null&&userId!='undefined'&&userId!=''){
			var params = {'userId':userId,'yearMonth':year+'-'+month};
  		//this.webService.post(MONTHTRIPLIST,params,"查询月行程").then(anyObj =>this.handleMonthTripList(anyObj));
  		this.dateListInit(this.type);
			this.tripList = null;
		}
  }
  handleMonthTripList(obj:any){
  	if(obj){
			this.tripList=obj.monthList;
			this.dateListInit(this.type);
			this.tripShowList();
		}else{
			this.dateListInit(this.type);
			this.tripList = null;
		}
  }

  getWeekTripList(userId:string){
  	if(userId!=null&&userId!='undefined'&&userId!=''){
	  	var prevMNum = this.isWeekNum(this.selDay);//本周该天之前可以显示数
	  	var ymd = this.addDate(this.selDay,0-prevMNum,'YYYY-MM-dd');
	  	var ymd2 = this.addDate(this.selDay,6-prevMNum,'YYYY-MM-dd');
	  	var params = {'userId':userId,'startDate':ymd,'endDate':ymd2};
	  	//this.webService.post(WEEKTRIPLIST,params,"查询周行程").then(anyObj =>this.handleWeekTripList(anyObj));
	  	this.dateListInit(this.type);
			this.tripList = null;
	  }
  }

  handleWeekTripList(obj:any){
  	if(obj){
			this.tripList=obj.weekTripList;
			this.dateListInit(this.type);
			this.tripShowList();
		}else{
			this.dateListInit(this.type);
			this.tripList = null;
		}
  }
}




// WEBPACK FOOTER //
// ./src/pages/trip/trip.ts